import React, { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { SlotItem } from "../slot-item/slot-item";
import { ISlot } from "../../../types";
import { selectionStore } from "../../../stores/selection.store";
import { selectionStoreChangesService } from "../../../services/selection-store-changes.service";
import { GolEventListener } from "../../calendar/calendar";
import { moduleSettings } from "../../../stores/module-settings.store";

interface IProps {
  sectionTitleKey: string;
  sectionTimeSlots: Array<ISlot>;
}

export const TimeSectionStyle = styled.div`
  width: 300px;
  font-size: 14px;
`;

export const TimeSectionTitle = styled.div`
  margin-left: 8px;
  margin-top: 12px;
  font-weight: bold;
`;

const Time = (props: IProps) => {
  const { t } = useTranslation();
  const [selectedTime, setSelectedTime] = useState(selectionStore.time);

  const storeSelectedTime = (value: any): void => {
    setSelectedTime(value);
    selectionStore.time = value;
    selectionStoreChangesService.dispatch(GolEventListener.Time);
  };

  useEffect(() => {
    selectionStoreChangesService.registerListener(
      "selection-time",
      [GolEventListener.Time],
      () => {
        setSelectedTime(selectionStore.time);
      }
    );

    return () => {
      selectionStoreChangesService.unregisterListener("selection-time");
    };
  }, []);

  const timeSlots = props.sectionTimeSlots.map((timeSlot: ISlot) => {
    return (
      <SlotItem
        icons={{
          hasWaitingList: timeSlot.icons?.hasWaitingList,
          hasOffer: timeSlot.icons?.hasOffer,
          hasPrepayment: timeSlot.icons?.hasPrepayment,
        }}
        value={timeSlot.value}
        key={timeSlot.value}
        isSelected={timeSlot.value === selectedTime}
        onClick={storeSelectedTime}
      />
    );
  });
  return (
    <TimeSectionStyle data-test="time-section">
      <TimeSectionTitle>
        {moduleSettings.renamingPeriod(props.sectionTitleKey)}
      </TimeSectionTitle>
      <div className="timeSlots">{timeSlots}</div>
    </TimeSectionStyle>
  );
};
export const TimeSection = memo(Time);
